export default __webpack_public_path__ + "static/media/187615.cd37241a.jpg";